const ScaleEvent = ({ activity }) => {

  return (
    <section
      className="scale-event-section mb-50"
      data-aos="fade-up"
    >
      <div className="container">

        <div className="section-title2 primary3 text-start">
          <span>{activity?.highlist_title}</span>

          {activity?.title && (
            <h2>{activity?.title}</h2>
          )}

          <p className="title">
              {activity?.sub_title}
          </p>
        </div>

        <div className="glass-effect">
          <ul className="a-list">
           {activity?.services_list?.length > 0 &&
              activity.services_list.map((item) => (
              <li>
                <span className="mon">
                    {item.services_sub_title}
                </span>
                <span className="evt">
                    {item.title}
                </span>
              </li>
            ))}
          </ul>
        </div>

      </div>
    </section>
  );
};

export default ScaleEvent;